var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.978,
    cy: 42.138000000000005,
    r: 19.408,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,193,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.977 17.726 c -0.559 0 -1.011 -0.453 -1.011 -1.011 v -6.586 c 0 -0.558 0.452 -1.011 1.011 -1.011 s 1.011 0.453 1.011 1.011 v 6.586 C 57.988 17.273 57.536 17.726 56.977 17.726 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,193,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.989 43.152 h -6.587 c -0.559 0 -1.011 -0.453 -1.011 -1.011 c 0 -0.558 0.452 -1.011 1.011 -1.011 h 6.587 c 0.559 0 1.011 0.453 1.011 1.011 C 90 42.699 89.548 43.152 88.989 43.152 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,193,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.998 25.173 c -0.259 0 -0.517 -0.099 -0.715 -0.296 l -4.657 -4.657 c -0.395 -0.395 -0.395 -1.035 0 -1.43 s 1.035 -0.395 1.43 0 l 4.657 4.657 c 0.395 0.395 0.395 1.035 0 1.43 C 39.516 25.075 39.257 25.173 38.998 25.173 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,193,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.955 25.173 c -0.259 0 -0.517 -0.099 -0.715 -0.296 c -0.395 -0.395 -0.395 -1.035 0 -1.43 l 4.658 -4.657 c 0.395 -0.395 1.035 -0.395 1.43 0 c 0.395 0.395 0.395 1.035 0 1.43 l -4.658 4.657 C 75.472 25.075 75.214 25.173 74.955 25.173 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,193,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.855 55.787 c -0.032 -0.479 -0.054 -0.961 -0.054 -1.449 c 0 -11.881 9.632 -21.513 21.513 -21.513 c 8.595 0 16.011 5.042 19.456 12.329 c 2.595 -1.842 5.759 -2.936 9.184 -2.936 c 7.924 0 14.475 5.805 15.68 13.39 c 5.456 1.493 9.472 6.473 9.472 12.403 c 0 7.109 -5.763 12.872 -12.872 12.872 H 12.872 C 5.763 80.883 0 75.12 0 68.011 C 0 62.306 3.715 57.475 8.855 55.787 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(98,195,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunCloud);
export default __webpack_public_path__ + "static/media/sun-cloud.901930d797561f8e656dea878a1c06d4.svg";
export { ForwardRef as ReactComponent };